module.exports = __webpack_public_path__ + "static/img/13a.f27cbbd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/13a.jpg
// module id = yAzW
// module chunks = 1